import React, { useEffect, useRef, useState } from 'react';
import styles from './MiniSelect.module.css';

export default function MiniSelect({ value, onChange, options, placeholder = 'Selecione' }) {
  const [aberto, setAberto] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickFora(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setAberto(false);
      }
    }
    document.addEventListener('mousedown', handleClickFora);
    return () => document.removeEventListener('mousedown', handleClickFora);
  }, []);

  const selecionado = options.find((option) => option.value === value);

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => setAberto((prev) => !prev)}
      >
        <span>{selecionado?.label ?? placeholder}</span>
        <i className={`fa fa-chevron-down ${styles.chevron} ${aberto ? styles.chevronAberto : ''}`} />
      </button>

      {aberto && (
        <div className={styles.menu}>
          {options.map((option) => (
            <button
              type="button"
              key={option.value}
              className={`${styles.option} ${option.value === value ? styles.optionAtiva : ''}`}
              onClick={() => {
                onChange(option.value);
                setAberto(false);
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
